import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import TimePicker from './TimePicker';
import { transformEndTimeChange, transformStartTimeChange } from './utils';

type Props = {
  className?: string;
  onChange: (value: { startMinutes: number; endMinutes: number }) => void;
  value: { startMinutes: number; endMinutes: number };
};

const Root = styled.div`
  display: flex;
`;

const TimeInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
`;

const TimeInputSeparator = styled(T.Body3)`
  width: 16px;
  text-align: center;
`;

const TimeInput = styled(TimePicker)`
  flex: 1;
  width: 64px;
`;

const TimePairInput = ({ className, onChange, value }: Props) => {
  return (
    <Root className={className}>
      <TimeInputsContainer>
        <TimeInput
          onChange={newValue => {
            const newTimePair = transformStartTimeChange(value.endMinutes, newValue);
            onChange(newTimePair);
          }}
          value={value.startMinutes % (24 * 60)}
        />
        <TimeInputSeparator>{' - '}</TimeInputSeparator>
        <TimeInput
          onChange={newValue => {
            const newTimePair = transformEndTimeChange(value.startMinutes, newValue);
            onChange(newTimePair);
          }}
          value={value.endMinutes % (24 * 60)}
        />
      </TimeInputsContainer>
    </Root>
  );
};

export default TimePairInput;
